import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { Link, NavLink, Outlet } from 'react-router'
import { TopNav } from './TopNav'
import { UserCard } from './UserCard'
import Logo from './logo.svg?react'

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const drawerWidth = 240
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }

  const links: { to: string; label: string }[] = [
    { to: '/clients', label: 'Clients' },
    { to: '/projects', label: 'Projects' },
    { to: '/vendors', label: 'Vendors' },
    { to: '/contacts', label: 'Contacts' },
  ]

  const drawer = (
    <Stack flex={1}>
      <Stack alignItems="center" my={2}>
        <Box component={Logo} width={40} height={40} />
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Elastic Sales
        </Typography>
      </Stack>
      <Divider />
      <List sx={{ flex: 1 }}>
        {links.map((link) => (
          <ListItemButton key={link.to} component={NavLink} to={link.to} onClick={handleDrawerToggle}>
            <ListItemText primary={link.label} />
          </ListItemButton>
        ))}
      </List>
      <UserCard />
    </Stack>
  )

  return (
    <Box display="flex" flexDirection="row" height="100vh">
      <AppBar
        component="nav"
        color="primary"
        sx={{
          '& .MuiButton-root': {
            color: 'var(--color-text)',
            transition: 'all 0.3s',
          },
          '& .MuiButton-text.active': {
            opacity: 0.5,
          },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component={Link}
            to="/"
            display="flex"
            flexDirection="row"
            alignItems="center"
            sx={{
              textDecoration: 'none',
              color: 'var(--color-text)',
              mr: { sm: 'auto', md: 4 },
              flexGrow: { xs: 1, sm: 0 },
            }}
          >
            <Logo width={40} height={40} style={{ flex: '0 0 40px', marginRight: '0.5em' }} />
            <Typography variant="h6" component="div">
              Elastic Sales
            </Typography>
          </Box>

          <TopNav />
          <Box sx={{ ml: 'auto', display: { xs: 'none', sm: 'flex' }, mr: -2 }}>
            <UserCard sx={{ mr: 0, pr: 0, my: 0, py: 0, borderTop: 'none' }} />
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main" sx={{ p: { xs: 1, sm: 3 } }} flex="1" display="flex" flexDirection="column">
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  )
}
